import React, { FC } from 'react';
import { FeatureServiceFCO } from '../../../core/types/fcoTypes';
import { FCOMetadataCard, FCOTagsCard } from '@tecton/ComponentRedesign';
import FeatureServiceConfigCard from '../../featureServices/Redesign/FeatureServiceConfigCard';
import FeatureServiceCurlCard from '../../featureServices/Redesign/FeatureServiceCurlCard';
import FeatureServiceFeatureTable from '../../featureServices/Redesign/FeatureServiceFeatureTable';
import { FeatureServiceSummary } from '../../../core/types/featureServiceSummary';
import { ColumnLayout, FlexGroup, FlexItem } from '@lithos';

interface FeatureServiceOverviewProps {
  service: FeatureServiceFCO;
  fcos: any;
  workspace: string;
  servingSummary: FeatureServiceSummary; // This comes from useGetFeatureServiceSummary
  curlSummary: any; // This comes from useFeatureServiceSummary
  // Unsure why these are so confusingly-named
}

const FeatureServiceOverview: FC<FeatureServiceOverviewProps> = ({
  service,
  fcos,
  workspace,
  servingSummary,
  curlSummary,
}) => {
  return (
    <>
      <FlexGroup padding="0" gapSize="8" css={{ overflow: 'scroll' }} direction="column">
        <FlexItem grow="1" shrink="0">
          <ColumnLayout>
            <FCOMetadataCard fco={service} />
            <FCOTagsCard fco={service} />
            <FeatureServiceConfigCard fco={service} fcos={fcos} summary={servingSummary} />
            <FeatureServiceCurlCard summary={curlSummary} />
          </ColumnLayout>
        </FlexItem>
        <FlexItem grow="1" shrink="0">
          <FeatureServiceFeatureTable fco={service} fcos={fcos} workspace={workspace} />
        </FlexItem>
      </FlexGroup>
    </>
  );
};

export default FeatureServiceOverview;
